var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 55,
    viewBox: "0 0 29 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo-01 1",
    clipPath: "url(#clip0_1_4716)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.4176 55C22.4717 33.0578 -6.92494 15.4715 8.06813 0C0.195599 13.7005 32.1292 35.42 12.4176 55Z",
    fill: "#2E94C0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.7885 3.25294C16.2322 1.95769 13.7228 2.53518 12.1802 4.54268C10.6376 6.55018 10.6542 9.21768 12.2105 10.5184C13.7668 11.8192 16.2762 11.2362 17.8188 9.22868C19.3613 7.22118 19.3448 4.54819 17.7885 3.25294Z",
    fill: "#2E94C0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.9688 16.8684C15.8721 13.2769 23.987 9.25917 29.0058 11.4289C25.8546 11.5857 17.9628 16.8189 14.9575 20.6277C14.7262 20.2647 12.9688 16.8684 12.9688 16.8684Z",
    fill: "#2E4DA1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M1.07086 12.4248C0.0737139 15.4168 -1.19889 22.1626 2.30491 29.7278C6.57448 38.9458 9.42269 40.5271 11.899 49.9898C12.9678 33.3276 3.24972 26.0786 1.07086 12.4248Z",
    fill: "#2E4DA1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_4716"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 55,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a9c5e4f30a99ba331f252db5a786d6ac.svg";
export { ForwardRef as ReactComponent };